import { createSlice } from '@reduxjs/toolkit';

const flowSlice = createSlice({
  name: 'flow',
  initialState: {
    nodes: [],
    edges: [],
    selectedNode: null,
  },
  reducers: {
    setNodes(state, action) {
      state.nodes = action.payload;
    },
    setEdges(state, action) {
      state.edges = action.payload;
    },
    addNode(state, action) {
      state.nodes.push(action.payload);
    },
    removeNode(state, action) {
      const id = action.payload;
      state.nodes = state.nodes.filter((n) => n.id !== id);
      state.edges = state.edges.filter((e) => e.source !== id && e.target !== id);
      if (state.selectedNode?.id === id) state.selectedNode = null;
    },
    updateNodeData(state, action) {
      const { id, data } = action.payload;
      const node = state.nodes.find((n) => n.id === id);
      if (node) node.data = { ...node.data, ...data };
      if (state.selectedNode?.id === id) {
        state.selectedNode = { ...state.selectedNode, data: { ...state.selectedNode.data, ...data } };
      }
    },
    selectNode(state, action) {
      state.selectedNode = action.payload;
    },
    addEdge(state, action) {
      state.edges.push(action.payload);
    },
    loadFlow(state, action) {
      state.nodes = action.payload.nodes || [];
      state.edges = action.payload.edges || [];
      state.selectedNode = null;
    },
    clearFlow(state) {
      state.nodes = [];
      state.edges = [];
      state.selectedNode = null;
    },
  },
});

export const {
  setNodes, setEdges, addNode, removeNode, updateNodeData,
  selectNode, addEdge, loadFlow, clearFlow,
} = flowSlice.actions;
export default flowSlice.reducer;
